import api from '../../store/config/api';
import { TASK as SCHEMA, RUN as RUN_SCHEMA } from '../../schemas';
import { format } from '../../util/url';

export const [
  GET_TASK,
  GET_TASK_REQUEST,
  GET_TASK_SUCCESS,
  GET_TASK_FAILURE
] = api.buildTypes('GET_TASK');

export function getTask({ teamName, runID, taskName }) {
  return {
    type: GET_TASK,
    payload: {
      url: `/teams/${teamName}/runs/${runID}/tasks/${taskName}`,
      schema: SCHEMA,
      options: {
        method: 'GET'
      }
    }
  };
}

export function getTaskByID({ teamName, taskID }) {
  return {
    type: GET_TASK,
    payload: {
      url: `/teams/${teamName}/tasks/${taskID}`,
      schema: SCHEMA,
      options: {
        method: 'GET'
      }
    }
  };
}

export const [
  ADD_TASK,
  ADD_TASK_REQUEST,
  ADD_TASK_SUCCESS,
  ADD_TASK_FAILURE
] = api.buildTypes('ADD_TASK');

export function addTask({ teamName, runID, task = {} }) {
  return {
    type: ADD_TASK,
    payload: {
      url: `/teams/${teamName}/runs/${runID}/tasks`,
      schema: SCHEMA,
      options: {
        method: 'POST',
        body: task
      }
    }
  };
}

export const [
  UPDATE_TASK,
  UPDATE_TASK_REQUEST,
  UPDATE_TASK_SUCCESS,
  UPDATE_TASK_FAILURE
] = api.buildTypes('UPDATE_TASK');

export const updateTask = ({ teamName, runID, taskName, task = {} }) => ({
  type: UPDATE_TASK,
  payload: {
    url: `/teams/${teamName}/runs/${runID}/tasks/${taskName}`,
    schema: SCHEMA,
    options: {
      method: 'PUT',
      body: task
    }
  }
});

export const [
  COMPLETE_TASK,
  COMPLETE_TASK_REQUEST,
  COMPLETE_TASK_SUCCESS,
  COMPLETE_TASK_FAILURE
] = api.buildTypes('COMPLETE_TASK');

export const completeTask = ({ teamName, runID, taskName, body }) => ({
  type: COMPLETE_TASK,
  payload: {
    url: `/teams/${teamName}/runs/${runID}/tasks/${taskName}/complete`,
    schema: SCHEMA,
    options: {
      method: 'POST',
      body
    }
  }
});

export const skipTask = ({ task = {}, ...options }) =>
  updateTask({
    ...options,
    task: { ...task, status: 'skipped' }
  });

export const rejectTask = ({ task = {}, ...options }, reason) =>
  updateTask({
    ...options,
    task: { ...task, status: 'rejected', reason }
  });

export const waitTask = ({ task = {}, ...options }, requiredPreviousTasks) =>
  updateTask({
    ...options,
    task: { ...task, status: 'waiting', requiredPreviousTasks }
  });

export const updateTaskRole = ({ teamName, runID, taskName, role = {} }) => ({
  type: UPDATE_TASK,
  payload: {
    url: `/teams/${teamName}/runs/${runID}/tasks/${taskName}/role`,
    options: {
      method: 'PUT',
      body: role
    }
  }
});

export const [
  REOPEN_TASK,
  REOPEN_TASK_REQUEST,
  REOPEN_TASK_SUCCESS,
  REOPEN_TASK_FAILURE
] = api.buildTypes('REOPEN_TASK');

export const reopenTask = ({ teamName, runID, task }) => {
  const url = format({
    pathname: `/teams/${teamName}/runs/${runID}/reopen`,
    query: {
      includeSkipped: true,
      optional: true
    }
  });
  return {
    type: REOPEN_TASK,
    payload: {
      url,
      schema: RUN_SCHEMA,
      options: {
        method: 'POST',
        body: { tasks: [task] }
      }
    }
  };
};

export const [
  ADD_AD_HOC_TASK,
  ADD_AD_HOC_TASK_REQUEST,
  ADD_AD_HOC_TASK_SUCCESS,
  ADD_AD_HOC_TASK_FAILURE
] = api.buildTypes('ADD_AD_HOC_TASK');

export function createAdHocTask({ teamName, task = {} }) {
  return {
    type: ADD_AD_HOC_TASK,
    payload: {
      url: `/teams/${teamName}/tasks`,
      schema: SCHEMA,
      options: {
        method: 'POST',
        body: task
      }
    }
  };
}



// WEBPACK FOOTER //
// ./js/actions/api/task.js